module.exports = __webpack_public_path__ + "img/ru-flag.c364cdb3.svg";